/**
 * Browser-style tab overflow: how many report pills fit before the trailing
 * "+N" chip is needed. Pure so it can be unit-tested without a layout engine.
 *
 * `gap` is the single spacing token shared by the inter-pill gaps and the
 * pill-to-chip gap (both measured from the live strip, never assumed).
 */
export const computeVisibleCount = (
  pillWidths: number[],
  chipWidth: number,
  containerWidth: number,
  gap: number,
): number => {
  const total = pillWidths.length;
  if (total <= 1) return total;

  const widthOfFirst = (count: number): number =>
    pillWidths.slice(0, count).reduce((sum, width) => sum + width, 0) +
    gap * (count - 1);

  if (widthOfFirst(total) <= containerWidth) return total;

  for (let count = total - 1; count >= 1; count--) {
    if (widthOfFirst(count) + gap + chipWidth <= containerWidth) return count;
  }

  return 1;
};
